import React, { useContext, useEffect, useRef } from 'react';
import Authorized from '#GameFrontend/authorized/authorized';
import Unauthorized from '#GameFrontend/unauthorized/unauthorized';
import { isPublicPath } from '#GameFrontend/lib/publicPaths';
import { socket } from '#GameFrontend/services/socket';
import { UserContext } from '#GameFrontend/contexts/UserContext';
import moment from 'moment';
import Cookies from 'js-cookie';

function setViewportHeight() {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setViewportHeight();
window.addEventListener('resize', setViewportHeight);

function App() {
	const { state, authReady } = useContext(UserContext);
	const socketInitialized = useRef(false);

	useEffect(() => {
		if (!authReady) {
			return;
		}
		if (!state.isAuthorized && !isPublicPath(window.location.pathname)) {
			window.location.replace('/');
		}
	}, [authReady, state.isAuthorized]);

	useEffect(() => {
		if (!socketInitialized.current) {
			socket.on('connect', () => {
				socket.off('connection');
				socket.on('connection', () => {
					const cookieState = Cookies.get('userState');
					if (cookieState !== undefined) {
						const { username, lssk, validUntil } = JSON.parse(cookieState);
						if (moment(validUntil).unix() >= moment().unix()) {
							socket.timeout(5000).emit('User:Login', { username, lssk }, () => {});
						}
					}
				});
			});

			socket.on('disconnect', () => {});
			socketInitialized.current = true;
		}

		return () => {
			socket.off('connect');
			socket.off('disconnect');
			socket.off('connection');
		};
	}, []);

	if (!authReady) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-[#1a120b] text-white">
				<p className="text-lg opacity-80">Loading…</p>
			</div>
		);
	}

	return state.isAuthorized ? <Authorized /> : <Unauthorized />;
}

export default App;
